import { acceptInvitationMutation, getMeQueryKey } from "@payezy/api-client/public/query";
import { Alert, Button, Card } from "@payezy/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { Brand } from "../components/Brand";
import { kratos, problemMessage } from "../lib/api";
import { useMe } from "../lib/org";

export function AcceptInvitationPage() {
  const me = useMe();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") ?? "";
  const accept = useMutation({
    ...acceptInvitationMutation(),
    onSuccess: async (m) => {
      await qc.invalidateQueries({ queryKey: getMeQueryKey() });
      navigate({ to: "/o/$orgId", params: { orgId: m.org_id } });
    },
  });
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4">
      <Brand className="mb-8" />
      <Card className="w-full max-w-sm p-6">
        <h1 className="text-lg font-semibold">Join your team</h1>
        <p className="mt-1 text-sm text-ink-500">You're signed in as {me.user.email}.</p>
        {accept.isError && <Alert tone="danger" className="mt-4">{problemMessage(accept.error)}</Alert>}
        <div className="mt-5 flex flex-col gap-2">
          <Button disabled={!token} loading={accept.isPending} onClick={() => accept.mutate({ body: { token } })}>Accept invitation</Button>
          <Button variant="ghost" onClick={() => void kratos.logout(window.location.href)}>Use a different account</Button>
        </div>
      </Card>
    </div>
  );
}
